import { useMenuSection } from '@react-aria/menu'
import { MenuItem } from './MenuItem'
import { MenuSectionProps } from './Types'
import Styles from './MenuSection.module.scss'
import { SubmenuItem } from './SubmenuItem'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'

const Header = ({ children, ...props }: PropsWithChildren<HTMLAttributes<HTMLElement>>) => {
  return (
    <h4 className={Styles.heading}>
      <Text
        variant="label"
        color="var(--override-menu-section-header-color, var(--menu-section-header-color))"
        {...props}
      >
        {children}
      </Text>
    </h4>
  )
}

export const MenuSection = <T,>({
  section,
  state,
  showCheckmark,
  showCheckbox,
  onClose,
  onAction,
  itemClassName,
  menuType = 'dropdown',
}: MenuSectionProps<T>) => {
  let { itemProps, headingProps, groupProps } = useMenuSection({
    heading: section.rendered,
    'aria-label': section['aria-label'],
  })

  return (
    <li {...itemProps} className={Styles[menuType]}>
      {section.rendered && <Header {...headingProps}>{section.rendered}</Header>}
      <ul {...groupProps} className={cx(Styles.group, Styles[menuType])}>
        {[...section.childNodes].map((node) => {
          const MenuItemComponent =
            Array.isArray(node.rendered) && typeof node.rendered[node.rendered.length - 1] === 'function'
              ? SubmenuItem
              : MenuItem
          return (
            <MenuItemComponent
              className={itemClassName}
              key={node.key}
              item={node}
              state={state}
              onAction={onAction}
              onClose={onClose}
              showCheckmark={showCheckmark}
              showCheckbox={showCheckbox && !node.props['data-hide-checkbox']}
              closeOnSelect={node.props['data-close-on-select']}
              menuType={menuType}
            />
          )
        })}
      </ul>
    </li>
  )
}
